const preloadImages = (imageArray) => {
    imageArray.forEach((image) => {
      const img = new Image();
      img.src = image;
    });
  };
  
  export default preloadImages;